export default __webpack_public_path__ + "static/indie-app-d9c02c35139341f82a67e54ba4f39cc3.png";